import queryString from 'query-string'
import api from '@utils/api'
import {http} from '@utils'

export default {
    namespaced: true,
    actions:{
        async getCMSConfig({ commit }) {
            const res = await http.get(`${api.cmsHost}/publish/976/aboutpage.json`)
            return res
        },
    }
}